import _objectWithoutProperties from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _asyncToGenerator from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _toConsumableArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
import React from 'react';
import { autorun, when } from 'mobx';
import { addDisposer, getSnapshot, isAlive, types } from 'mobx-state-tree';
import deepEqual from 'fast-deep-equal';
// jbrowse
import { ConfigurationReference, getConf } from '@jbrowse/core/configuration';
import { BaseDisplay } from '@jbrowse/core/pluggableElementTypes/models';
var minDisplayHeight = 20;
function getLowerPanelDisplays(pluginManager) {
  return pluginManager.getDisplayElements()
  // @ts-ignore
  .filter(function (f) {
    var _a;
    return ((_a = f.subDisplay) === null || _a === void 0 ? void 0 : _a.type) === 'LinearAlignmentsDisplay';
  })
  // @ts-ignore
  .filter(function (f) {
    var _a;
    return (_a = f.subDisplay) === null || _a === void 0 ? void 0 : _a.lowerPanel;
  });
}
function deepSnap(x1, x2) {
  return deepEqual(x1 ? getSnapshot(x1) : undefined, x2 ? getSnapshot(x2) : undefined);
}
function preCheck(self) {
  var PileupDisplay = self.PileupDisplay,
    SNPCoverageDisplay = self.SNPCoverageDisplay;
  return PileupDisplay || isAlive(PileupDisplay) || SNPCoverageDisplay || isAlive(SNPCoverageDisplay);
}
function propagateColorBy(self) {
  var PileupDisplay = self.PileupDisplay,
    SNPCoverageDisplay = self.SNPCoverageDisplay;
  if (!preCheck(self) || !PileupDisplay.colorBy) {
    return;
  }
  if (!deepSnap(PileupDisplay.colorBy, SNPCoverageDisplay.colorBy)) {
    SNPCoverageDisplay.setColorBy(getSnapshot(PileupDisplay.colorBy));
  }
}
function propagateFilterBy(self) {
  var PileupDisplay = self.PileupDisplay,
    SNPCoverageDisplay = self.SNPCoverageDisplay;
  if (!preCheck(self) || !PileupDisplay.filterBy) {
    return;
  }
  if (!deepSnap(PileupDisplay.filterBy, SNPCoverageDisplay.filterBy)) {
    SNPCoverageDisplay.setFilterBy(getSnapshot(PileupDisplay.filterBy));
  }
}
function AlignmentsModel(pluginManager, configSchema) {
  var lowerPanelDisplays = getLowerPanelDisplays(pluginManager).map(function (f) {
    return f.stateModel;
  });
  return types.model({
    /**
     * #property
     * refers to LinearPileupDisplay sub-display model
     */
    // @ts-ignore
    PileupDisplay: types.maybe(types.union.apply(types, _toConsumableArray(lowerPanelDisplays))),
    /**
     * #property
     * refers to LinearSNPCoverageDisplay sub-display model
     */
    SNPCoverageDisplay: types.maybe(pluginManager.getDisplayType('LinearSNPCoverageDisplay').stateModel),
    /**
     * #property
     */
    snpCovHeight: 45,
    /**
     * #property
     */
    type: types.literal('LinearAlignmentsDisplay'),
    /**
     * #property
     */
    configuration: ConfigurationReference(configSchema),
    /**
     * #property
     */
    heightPreConfig: types.maybe(types.number),
    /**
     * #property
     */
    userFeatureScreenDensity: types.maybe(types.number),
    /**
     * #property
     */
    lowerPanelType: 'LinearPileupDisplay'
  });
}
/**
 * #stateModel LinearAlignmentsDisplay
 * extends `BaseDisplay`
 */
function stateModelFactory(pluginManager, configSchema) {
  return types.compose('LinearAlignmentsDisplay', BaseDisplay, AlignmentsModel(pluginManager, configSchema)).volatile(function () {
    return {
      scrollTop: 0
    };
  }).actions(function (self) {
    return {
      /**
       * #action
       */
      setScrollTop: function setScrollTop(scrollTop) {
        self.scrollTop = scrollTop;
      },
      /**
       * #action
       */
      setSNPCoverageHeight: function setSNPCoverageHeight(n) {
        self.snpCovHeight = n;
      }
    };
  }).views(function (self) {
    return {
      /**
       * #getter
       */
      get height() {
        var _a;
        return (_a = self.heightPreConfig) !== null && _a !== void 0 ? _a : getConf(self, 'height');
      }
    };
  }).views(function (self) {
    return {
      /**
       * #getter
       */
      get pileupConf() {
        var conf = getConf(self, 'pileupDisplay');
        return _objectSpread({}, conf, {
          type: self.lowerPanelType,
          displayId: "".concat(self.configuration.displayId, "_").concat(self.lowerPanelType, "_xyz") // xyz to avoid someone accidentally naming the displayId similar to this
        });
      },
      /**
       * #method
       */
      getFeatureByID: function getFeatureByID(blockKey, id) {
        return self.PileupDisplay.getFeatureByID(blockKey, id);
      },
      /**
       * #method
       */
      searchFeatureByID: function searchFeatureByID(id) {
        return self.PileupDisplay.searchFeatureByID(id);
      },
      /**
       * #getter
       */
      get features() {
        return self.PileupDisplay.features;
      },
      /**
       * #getter
       */
      get DisplayBlurb() {
        var _a;
        return (_a = self.PileupDisplay) === null || _a === void 0 ? void 0 : _a.DisplayBlurb;
      },
      /**
       * #getter
       */
      get sortedBy() {
        return self.PileupDisplay.sortedBy;
      },
      /**
       * #getter
       */
      get coverageConf() {
        var conf = getConf(self, 'snpCoverageDisplay');
        return _objectSpread({}, conf, {
          displayId: "".concat(self.configuration.displayId, "_snpcoverage_xyz") // xyz to avoid someone accidentally naming the displayId similar to this
        });
      }
    };
  }).actions(function (self) {
    return {
      /**
       * #action
       */
      setSNPCoverageDisplay: function setSNPCoverageDisplay(configuration) {
        self.SNPCoverageDisplay = {
          type: 'LinearSNPCoverageDisplay',
          configuration: configuration,
          height: self.snpCovHeight
        };
      },
      /**
       * #action
       */
      updateStatsLimit: function updateStatsLimit(stats) {
        self.PileupDisplay.updateStatsLimit(stats);
        self.SNPCoverageDisplay.updateStatsLimit(stats);
      },
      /**
       * #action
       */
      setPileupDisplay: function setPileupDisplay(configuration) {
        self.PileupDisplay = {
          type: configuration.type || 'LinearPileupDisplay',
          configuration: configuration
        };
      },
      /**
       * #action
       */
      setHeight: function setHeight(n) {
        self.heightPreConfig = Math.max(n, minDisplayHeight);
        return self.heightPreConfig;
      },
      /**
       * #action
       */
      setLowerPanelType: function setLowerPanelType(type) {
        self.lowerPanelType = type;
      },
      /**
       * #action
       */
      resizeHeight: function resizeHeight(distance) {
        var oldHeight = self.height;
        var newHeight = this.setHeight(self.height + distance);
        return newHeight - oldHeight;
      }
    };
  }).actions(function (self) {
    return {
      afterAttach: function afterAttach() {
        addDisposer(self, autorun(function () {
          var SNPCoverageDisplay = self.SNPCoverageDisplay,
            PileupDisplay = self.PileupDisplay,
            coverageConf = self.coverageConf,
            pileupConf = self.pileupConf;
          if (!SNPCoverageDisplay) {
            self.setSNPCoverageDisplay(coverageConf);
          } else if (!deepEqual(coverageConf, getSnapshot(SNPCoverageDisplay.configuration))) {
            SNPCoverageDisplay.setHeight(self.snpCovHeight);
            SNPCoverageDisplay.setConfig(self.coverageConf);
          }
          if (!PileupDisplay || self.lowerPanelType !== PileupDisplay.type) {
            self.setPileupDisplay(pileupConf);
          } else if (!deepEqual(pileupConf, getSnapshot(PileupDisplay.configuration))) {
            PileupDisplay.setConfig(self.pileupConf);
          }
          propagateColorBy(self);
          propagateFilterBy(self);
        }));
        addDisposer(self, autorun(function () {
          self.setSNPCoverageHeight(self.SNPCoverageDisplay.height);
        }));
        addDisposer(self, autorun(function () {
          self.PileupDisplay.setHeight(self.height - self.SNPCoverageDisplay.height);
        }));
      },
      /**
       * #action
       */
      renderSvg: function () {
        var _renderSvg = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(opts) {
          var pileupHeight;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                pileupHeight = self.height - self.SNPCoverageDisplay.height;
                _context.next = 3;
                return when(function () {
                  return self.PileupDisplay.ready;
                });
              case 3:
                _context.t0 = React;
                _context.t1 = React.Fragment;
                _context.t2 = React;
                _context.next = 8;
                return self.SNPCoverageDisplay.renderSvg(opts);
              case 8:
                _context.t3 = _context.sent;
                _context.t4 = _context.t2.createElement.call(_context.t2, "g", null, _context.t3);
                _context.t5 = React;
                _context.t6 = {
                  transform: "translate(0 ".concat(self.SNPCoverageDisplay.height, ")")
                };
                _context.next = 14;
                return self.PileupDisplay.renderSvg(_objectSpread({}, opts, {
                  overrideHeight: pileupHeight
                }));
              case 14:
                _context.t7 = _context.sent;
                _context.t8 = _context.t5.createElement.call(_context.t5, "g", _context.t6, _context.t7);
                return _context.abrupt("return", _context.t0.createElement.call(_context.t0, _context.t1, null, _context.t4, _context.t8));
              case 17:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function renderSvg(_x) {
          return _renderSvg.apply(this, arguments);
        }
        return renderSvg;
      }()
    };
  }).views(function (self) {
    var superTrackMenuItems = self.trackMenuItems;
    return {
      /**
       * #method
       */
      trackMenuItems: function trackMenuItems() {
        var extra = getLowerPanelDisplays(pluginManager).map(function (d) {
          return {
            type: 'radio',
            label: d.displayName,
            checked: d.name === self.PileupDisplay.type,
            onClick: function onClick() {
              return self.setLowerPanelType(d.name);
            }
          };
        });
        return [].concat(_toConsumableArray(superTrackMenuItems()), [{
          type: 'subMenu',
          label: 'Pileup settings',
          subMenu: self.PileupDisplay.trackMenuItems()
        }, {
          type: 'subMenu',
          label: 'SNPCoverage settings',
          subMenu: self.SNPCoverageDisplay.trackMenuItems()
        }, {
          type: 'subMenu',
          label: "Replace lower panel with...",
          subMenu: extra
        }]);
      }
    };
  }).preProcessSnapshot(function (snap) {
    if (!snap) {
      return snap;
    }
    // @ts-ignore
    var height = snap.height,
      rest = _objectWithoutProperties(snap, ["height"]);
    return _objectSpread({
      heightPreConfig: height
    }, rest);
  });
}
export default stateModelFactory;